import ConfigurableBackground from './_configurable-background.js'
import ConfigurableBorder from './_configurable-border.js'
import ConfigurableText from './_configurable-text.js'
import ConfigurableMargin from './_configurable-margin.js'
import ConfigurablePadding from './_configurable-padding.js'
import Hideable from './_hideable.js'
import ImageButton from './_image-button.js'
import FlexPane from './_flex-pane.js'
import BannerPromotions from './_banner-promotions.js'

export default {
  name: 'AppViewSportsbook',
  values: {
    style: {
      mainContainer: {
        minWidth: undefined,
        _desktop_minWidth: '1280px',
        _mobile_margin: 'env(safe-area-inset-top, 0px) env(safe-area-inset-right, 0px) env(safe-area-inset-bottom, 0px) env(safe-area-inset-left, 0px)',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurableBorder,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableMargin,
          },
        ],
      },
      container: {
        maxWidth: '100%',
        _desktop_maxWidth: '1438px',
        isolation: 'isolate',
        $mixin: [
          {
            configSet: ConfigurableBackground,
          },
          {
            configSet: ConfigurablePadding,
          },
        ],
      },
    },
    hideSideMenu: false,
    _mobile_hideSideMenu: true,
    applicationHeader: {
      configSet: Hideable,
      configValues: {},
    },
    applicationFooter: {
      configSet: Hideable,
      configValues: {},
    },
    backToTopButtonToggle: {
      configSet: Hideable,
      configValues: {},
    },
    backToTopButtonConfig: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              minHeight: '40px',
              alignSelf: 'center',
              alignItems: 'flex-end',
              padding: '80px 0 0 220px',
              _mobile_padding: '80px 0 0 0',
            },
          },
        },
        buttonIcon: {
          src: 'chevron-up',
          style: {
            minWidth: '16px',
            minHeight: '16px',
          },
        },
        innerContainer: {
          style: {
            padding: '8px',
          },
        },
      },
    },
    sideMenuContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          width: '304px',
          padding: '8px 0 0',
          flexGrow: 0,
          flexShrink: 0,
          height: '100%',
        },
      },
    },
    quickLinks: {
      configSet: Hideable,
      configValues: {
        _desktop_hide: true,
      },
    },
    betslipPromotions: {
      configSet: BannerPromotions,
      configValues: {
        view: {
          bannerSkeletons: {
            container: {
              style: {
                aspectRatio: '1 / 1',
              },
            },
          },
        },
      },
    },
    accaBar: {
      configSet: Hideable,
      configValues: {
        hide: false,
        _desktop_hide: true,
      },
    },
  },
  meta: {
    extendable: false,
  },
}
